import { Typography } from "components/common/Typography";
import { ScenarioTemplateSet } from "components/scenarioManegement/ScenarioExpand/hook";
import {
  TEMPLATE_MONITOR_VARIABLE,
  TRANSLATE_MEETING_ROLE,
} from "constants/constant";
import React from "react";
import { MeetingRoleType } from "types/originalTypes";

import {
  StyledLi,
  StyledScenarioArea,
  StyledScenarioContainerDiv,
  StyledTemplateArea,
  StyledUl,
} from "./styled";

type ScenarioPreviewProps = {
  scenarioTemplateSet: ScenarioTemplateSet[];
};

export const ScenarioPreview: React.FC<ScenarioPreviewProps> = ({
  scenarioTemplateSet,
}) => {
  const reg = new RegExp("(\\$\\{" + MeetingRoleType.MONITOR + "\\})");

  return (
    <>
      {scenarioTemplateSet.map((set, index) => {
        const scenario = set.scenario;
        return (
          <StyledScenarioContainerDiv key={index}>
            <StyledScenarioArea>
              <Typography text={`${scenario.text}`} fontSize="medium" />
            </StyledScenarioArea>

            <StyledTemplateArea>
              <StyledUl>
                {set.templates.map((template, index) => {
                  if (!template.text) return;
                  if (template.text.indexOf(TEMPLATE_MONITOR_VARIABLE) !== -1) {
                    const templateArray = template.text.split(reg);
                    return (
                      <StyledLi key={index}>
                        {templateArray.map((word, index) => {
                          if (word === TEMPLATE_MONITOR_VARIABLE) {
                            return (
                              <Typography
                                text={word.replace(
                                  TEMPLATE_MONITOR_VARIABLE,
                                  TRANSLATE_MEETING_ROLE.MONITOR
                                )}
                                fontSize="medium"
                                color="#E77C1A"
                                backgroundColor="#e77d1a1e"
                                lineHeight="1.5"
                                key={index}
                              />
                            );
                          } else {
                            return (
                              <Typography
                                text={word}
                                fontSize="medium"
                                lineHeight="1.5"
                                key={index}
                              />
                            );
                          }
                        })}
                      </StyledLi>
                    );
                  } else {
                    return (
                      <StyledLi key={index}>
                        <Typography
                          text={template.text}
                          fontSize="medium"
                          lineHeight="1.5"
                        />
                      </StyledLi>
                    );
                  }
                })}
              </StyledUl>
            </StyledTemplateArea>
          </StyledScenarioContainerDiv>
        );
      })}
    </>
  );
};
